import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Directive, HostListener, input, output } from '@angular/core';

@Directive({ selector: '[r2eSwipeable]' })
export class SwipeableDirective {
  verticalSwipe = input(false, { transform: coerceBooleanProperty });

  swipeDown = output<void>();
  swipeLeft = output<void>();
  swipeRight = output<void>();
  swipeUp = output<void>();

  private swipeStartCoords: number[] = [];
  private swipeStartTime = 0;

  @HostListener('touchstart', ['$event']) startSwipe(event: TouchEvent) {
    const { clientX, clientY } = event.changedTouches[0];

    if (this.verticalSwipe()) { event.preventDefault(); }
    this.swipeStartCoords = [clientX, clientY];
    this.swipeStartTime = new Date().getTime();
  }

  @HostListener('touchend', ['$event']) endSwipe(event: TouchEvent) {
    const { clientX, clientY } = event.changedTouches[0];
    const directions = [clientX - this.swipeStartCoords[0], clientY - this.swipeStartCoords[1]];
    const duration = new Date().getTime() - this.swipeStartTime;

    if (this.verticalSwipe()) {
      if (this.swipeDetected(Math.abs(directions[1]), duration)) {
        if (directions[1] < 0) {
          this.swipeUp.emit();
        } else {
          this.swipeDown.emit();
        }
      }
    } else {
      if (this.swipeDetected(Math.abs(directions[0]), duration)) {
        if (directions[0] < 0) {
          this.swipeLeft.emit();
        } else {
          this.swipeRight.emit();
        }
      }
    }
  }

  private swipeDetected(distance: number, duration: number): boolean {
    const velocity = distance / duration;
    return velocity > 0.3 && distance > 20;
  }
}
